import React from 'react'
import { useIntl } from 'react-intl'

import { Order as OrderModel } from 'msp-integrations'
import translations from './OrderTransactionSummary.constants'
import * as S from './OrderTransactionSummary.styles'

const OrderTransactionSummary = ({ order }: { order: OrderModel }) => {
  const { formatMessage, formatNumber } = useIntl()

  return (
    <div className={S.Wrapper}>
      <div className={S.ContentWrapper}>
        <div className={S.SummaryItemWrapper}>
          <div className={S.SummaryItemName}>
            {formatMessage(translations.summaryTotalProducts)}
          </div>
          <div className={S.SummaryItemValue}>
            {formatNumber(order.productSubTotal, {
              style: 'currency',
              currency: order.currency,
              currencyDisplay: 'code'
            })}
          </div>
        </div>
        {order.hasPriceAdjustments() && (
          <div className={S.SummaryItemWrapper}>
            <div className={S.SummaryItemName}>
              {formatMessage(translations.summaryPromos)}
            </div>
            <div className={`${S.SummaryItemValue} ${S.SummaryItemPromo}`}>
              {formatNumber(order.getTotalOrderPriceAdjustments(), {
                style: 'currency',
                currency: order.currency,
                currencyDisplay: 'code'
              })}
            </div>
          </div>
        )}
        <div className={S.SummaryItemWrapper}>
          <div className={S.SummaryItemName}>
            {formatMessage(translations.summaryShipping)}
          </div>
          <div className={S.SummaryItemValue}>
            {formatNumber(order.shippingTotal, {
              style: 'currency',
              currency: order.currency,
              currencyDisplay: 'code'
            })}
          </div>
        </div>
        <div className={S.SummaryItemVatWrapper}>
          <div className={S.SummaryItemName}>
            {formatMessage(translations.summaryVAT)}
          </div>
          <div className={S.SummaryItemValue}>
            {formatNumber(order.taxTotal, {
              style: 'currency',
              currency: order.currency,
              currencyDisplay: 'code'
            })}
          </div>
        </div>
        <div className={S.SummaryItemTotalPriceWrapper}>
          <div className={S.SummaryItemName}>
            {formatMessage(translations.summaryOrderTotal)}
            <div className={S.SummaryItemTotalPriceIncVAT}>
              {formatMessage(translations.summaryOrderVAT)}
            </div>
          </div>
          <div className={S.SummaryItemValue}>
            {formatNumber(order.orderTotal, {
              style: 'currency',
              currency: order.currency,
              currencyDisplay: 'code'
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default OrderTransactionSummary
